/* istanbul ignore file */ /* plugin extension code */
// cSpell:ignore appboy

import Braze from '@braze/web-sdk';

import { getEnvVars } from '@order/utils';

import type { BrazeClient, BrazeUser } from './types';
import { runIfBrazeCredentialsProvided } from './utils';

// ────────────────────────────────────────────────────────────────────────────────

const { BRAZE_APP_ID_WEB, BRAZE_APP_SDK_ENDPOINT } = getEnvVars();

const init = runIfBrazeCredentialsProvided(() => {
  Braze.initialize(BRAZE_APP_ID_WEB, { baseUrl: BRAZE_APP_SDK_ENDPOINT });
  Braze.display.automaticallyShowNewInAppMessages();
});

const destroy = runIfBrazeCredentialsProvided(Braze.destroy);

const changeUser = runIfBrazeCredentialsProvided((user: BrazeUser) => {
  const { id, trackingUuid, email, firstName, lastName } = user;

  if (!id) return;

  Braze.changeUser(trackingUuid ?? id);

  if (email) Braze.getUser().setEmail(email);

  if (firstName) Braze.getUser().setFirstName(firstName);

  if (lastName) Braze.getUser().setLastName(lastName);

  Braze.openSession();
});

// ────────────────────────────────────────────────────────────────────────────────

export const client: BrazeClient = {
  init,
  destroy,
  changeUser,
};
